import Splide from '@splidejs/splide';
import { throttle } from '../utils/utilities';

const ROOT_SELECTOR = '[data-testimonials]';

// Три карточки в ряд — только от 1440: на 1024–1439 карточка 296–380px,
// и подпись автора («Founder, DevStudio») сталкивалась с источником
// («Private feedback») в одной строке. Ключи Splide — max-width.
const BREAKPOINTS = {
    1439: { perPage: 2, pagination: true },
    767: { perPage: 1, pagination: true },
};

/**
 * «Показать целиком» у длинных отзывов. Текст обрезает CSS (line-clamp),
 * поэтому до отрисовки не узнать, кому кнопка нужна: меряем по месту и
 * ставим карточке is-clamped. Раскрытую карточку при пересчёте не трогаем —
 * без обрезки текст всегда «влезает», и кнопка исчезла бы под рукой.
 */
const trackClamped = (root) => {
    const cards = Array.from(root.querySelectorAll('.template-testimonials__card'));

    const sync = () => {
        cards.forEach((card) => {
            if (card.classList.contains('is-expanded')) {
                return;
            }

            const quote = card.querySelector('.template-testimonials__quote');

            card.classList.toggle('is-clamped', !!quote && quote.scrollHeight > quote.clientHeight + 1);
        });
    };

    root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-testimonial-more]');

        if (!button) {
            return;
        }

        const card = button.closest('.template-testimonials__card');
        const expanded = card.classList.toggle('is-expanded');

        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
    });

    sync();

    window.addEventListener('resize', throttle(sync, 200), { passive: true });

    return sync;
};

export default function Testimonials() {
    const roots = Array.from(document.querySelectorAll(ROOT_SELECTOR));

    if (!roots.length) {
        return;
    }

    roots.forEach((root) => {
        const labels = root.dataset;

        const sync = trackClamped(root);

        const carousel = new Splide(root, {
            type: 'slide',
            perPage: 3,
            perMove: 1,

            gap: 'var(--grid-column-gap)',
            speed: 450,
            easing: 'cubic-bezier(.16, 1, .3, 1)',
            arrows: true,
            pagination: false,

            rewind: false,

            autoHeight: false,
            breakpoints: BREAKPOINTS,
            i18n: {
                carousel: labels.labelCarousel,
                prev: labels.labelPrev,
                next: labels.labelNext,
                slideX: labels.labelSelect,
            },
        });

        // Ширина карточки меняется на брейкпоинтах Splide, а с ней и число
        // строк: пересчитываем после того, как он разложил слайды.
        carousel.on('mounted resized', sync);

        carousel.mount();
    });
}
